"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const svg_1 = require("../../../svg");
exports.DynamicIntegrationLogo = ({ integrationType, size = '1.4em', width = size, height = size, className, }) => {
    if (integrationType === 'ContentSystem') {
        return (react_1.default.createElement(svg_1.IntegrationsLogo, { height: height, width: width, className: className }));
    }
    if (integrationType === 'Mailjet') {
        return react_1.default.createElement(svg_1.MailjetLogo, { height: height, width: width, className: className });
    }
    if (integrationType === 'Sailthru') {
        return react_1.default.createElement(svg_1.SailthruLogo, { height: height, width: width, className: className });
    }
    if (integrationType === 'Salesforce') {
        return (react_1.default.createElement(svg_1.SalesforceLogo, { height: height, width: width, className: className }));
    }
    if (integrationType === 'Mailchimp') {
        return (react_1.default.createElement(svg_1.MailchimpLogo, { height: height, width: width, className: className }));
    }
    if (integrationType === 'ActiveCampaign') {
        return (react_1.default.createElement(svg_1.ActiveCampaignLogo, { height: height, width: width, className: className }));
    }
    if (integrationType === 'CampaignMonitor') {
        return (react_1.default.createElement(svg_1.CampaignMonitorLogo, { height: height, width: width, className: className }));
    }
    return (react_1.default.createElement(svg_1.IntegrationsLogo, { height: height, width: width, className: className }));
};
//# sourceMappingURL=DynamicIntegrationLogo.js.map